import { DyteSpinner } from "@dytesdk/react-ui-kit";

function MeetingLoading() {
  /**
   * NOTE(ravindra-dyte): Don't like the default spinner?
   * You can replace DyteSpinner with your own screen, here.
   */
  return (
    <div className="flex h-full flex-col items-center justify-center">
      <DyteSpinner />
      <p className="text-gray-500">Starting session...</p>
    </div>
  );
}

export default MeetingLoading;
